import { render, staticRenderFns } from "./recipes-upload.vue?vue&type=template&id=2c14857c&scoped=true&"
import script from "./recipes-upload.vue?vue&type=script&lang=js&"
export * from "./recipes-upload.vue?vue&type=script&lang=js&"
import style0 from "./recipes-upload.vue?vue&type=style&index=0&id=2c14857c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14857c",
  null
  
)

export default component.exports